import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';

import { nl } from 'date-fns/locale';
import i18n from 'src/i18n/index.js';

const CURRENCY_SEPARATOR = ' ';

const locales = {
  'nl-NL': nl,
  'en-US': undefined, // fallback is en-us
};
export const formatDate = function (date, formatStr = 'PP') {
  if (typeof date === 'string') {
    date = parseISO(date);
  }

  return format(date, formatStr, {
    locale: locales[i18n.global.locale],
  }).replace('.', '');
};

export const formatDateWithoutTime = function (date, formatStr = 'PP') {
  if (typeof date === 'string') {
    date = date.split('T')[0];
    date = parseISO(date);
  }

  return format(date, formatStr, {
    locale: locales[i18n.global.locale],
  }).replace('.', '');
};

export function formatReverseDate(date) {
  if (!(date && date.length === 10)) return;
  if (date[4] === '/' && date[7] === '/') {
    return date.split('/').reverse().join('-');
  }
  if (date[2] === '-' && date[5] === '-') {
    return date.split('-').reverse().join('/');
  }
  return date;
}

export function formatCurrency(currency, stripSymbol) {
  var value = i18n.global.n(currency, 'currency', 'nl-NL');
  if (stripSymbol) {
    value = value.split(CURRENCY_SEPARATOR)[1];
  }
  return value;
}

export function formatCurrencyNoCents(currency, stripSymbol) {
  var value = i18n.global.n(currency, 'currencyNoCents', 'nl-NL');
  if (stripSymbol) {
    value = value.split(CURRENCY_SEPARATOR)[1];
  }
  return value;
}

export function isInteger(str) {
  const num = Number(str);
  return Number.isFinite(num) && Number.isInteger(num);
}

export function tryParseDate(dateStr, output) {
  if (isInteger(dateStr)) return false;
  const date = new Date(dateStr);
  var ret = !isNaN(date.getTime());
  if (ret) output.Date = date;
  return ret;
}

export const formatIban = (iban) => `${iban.substring(0, 4)} ${iban.substring(4, 8)} ${iban.substring(8)}`;
